export const environment = {
  production: true,
  host: '/',
  ws_host: 'ws://localhost/ws/',
  sentry_url: 'https://32e2035cc7cc4907a37869e233997fc1@o268405.ingest.sentry.io/6202078',
};
